import { createApp } from 'vue'
import App from './App.vue'
//安装的组件
import router from './router'
import store from './store'

import './utils/compatibleOldUrl.js'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

import { Tabbar, TabbarItem ,Form, Field, CellGroup,Button,RadioGroup, Radio,Checkbox, CheckboxGroup,
NavBar ,Switch ,Uploader ,Icon ,Step, Steps,Col, Row,ActionBar, ActionBarIcon, ActionBarButton,Stepper,
Popup ,List ,CountDown ,Toast ,Image as VanImage,Loading ,Overlay,ConfigProvider ,Sticky ,Circle ,
Cell,DatePicker,TimePicker,Skeleton,SkeletonTitle,SkeletonImage,SkeletonAvatar,SkeletonParagraph, 
Swipe, SwipeItem,Progress,Picker
} from 'vant';
import 'vant/lib/index.css';

import '@/assets/keens/plugins/global/plugins.bundle.css'
import '@/assets/css/global.css'

const app = createApp(App)
app.use(router)
app.use(store)
.use(ElementPlus)
app.use(Tabbar).use(TabbarItem).use(Form).use(Field).use(CellGroup).use(Button).use(RadioGroup).use(Radio)
.use(Checkbox).use(CheckboxGroup).use(NavBar).use(Switch).use(Uploader).use(Icon).use(Step).use(Steps)
.use(Col).use(Row).use(ActionBar).use(ActionBarIcon).use(ActionBarButton).use(Stepper).use(Popup)
.use(List).use(CountDown).use(Toast).use(VanImage).use(Loading).use(Overlay).use(ConfigProvider).use(Sticky).use(Circle)
.use(Cell).use(DatePicker).use(TimePicker).use(Skeleton).use(SkeletonTitle).use(SkeletonImage).use(SkeletonAvatar)
.use(SkeletonParagraph).use(Swipe).use(SwipeItem).use(Progress).use(Picker)
app.mount('#app')
